module.exports = __webpack_public_path__ + "static/img-27-4f051c57e39ab35c8de74a2760ab5b18.jpeg";